module.exports = __webpack_public_path__ + "site/img/25.80338bc2.jpg";